// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file settings/v1/shipping_rate_tier.proto (package settings.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file settings/v1/shipping_rate_tier.proto.
 */
export const file_settings_v1_shipping_rate_tier: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CiRzZXR0aW5ncy92MS9zaGlwcGluZ19yYXRlX3RpZXIucHJvdG8SC3NldHRpbmdzLnYxItgBChBTaGlwcGluZ1JhdGVUaWVyEhwKD21pbmltdW1fdHJhbnNpdBgBIAEoBEgAiAEBEhwKD21heGltdW1fdHJhbnNpdBgCIAEoBEgBiAEBEhQKB21pbmltdW0YAyABKAFIAogBARIUCgdtYXhpbXVtGAQgASgBSAOIAQESEgoFcHJpY2UYBSABKAFIBIgBAUISChBfbWluaW11bV90cmFuc2l0QhIKEF9tYXhpbXVtX3RyYW5zaXRCCgoIX21pbmltdW1CCgoIX21heGltdW1CCAoGX3ByaWNlQnsKD2NvbS5zZXR0aW5ncy52MUIVU2hpcHBpbmdSYXRlVGllclByb3RvUAFaBC4vcGKiAgNTWFiqAgtTZXR0aW5ncy5WMcoCC1NldHRpbmdzXFYx4gIXU2V0dGluZ3NcVjFcR1BCTWV0YWRhdGHqAgxTZXR0aW5nczo6VjFiBnByb3RvMw'
    );

/**
 * ShippingRateTier is one rate of a shipping rate definition: what the delivery
 * costs and how long it takes, between the bounds the tier applies on.
 *
 * It is nested under the definition rather than flattened next to it because
 * the name, the type, the currency and the free shipping threshold belong to
 * the definition and repeat across its tiers, while these numbers differ per
 * tier. This mirrors the shopify.v1 split of ShippingRateDefinition and
 * ShippingRateDefinitionRate, which is where the values are synced from.
 *
 * Every field is optional because Shopify leaves an open ended bound, a missing
 * transit estimate and a rate without a price unset rather than zero, and zero
 * is a meaningful value for all three.
 *
 * @generated from message settings.v1.ShippingRateTier
 */
export type ShippingRateTier = Message<'settings.v1.ShippingRateTier'> & {
    /**
     * transitTimeMinSeconds, the low end of the delivery estimate in seconds.
     *
     * @generated from field: optional uint64 minimum_transit = 1;
     */
    minimumTransit?: bigint | undefined;

    /**
     * transitTimeMaxSeconds, the high end of the delivery estimate in seconds.
     *
     * @generated from field: optional uint64 maximum_transit = 2;
     */
    maximumTransit?: bigint | undefined;

    /**
     * minimum and maximum are the inclusive bounds the tier applies between:
     * money in the definition currency for SHIPPING_RATE_DEFINITION_TYPE_ORDER_AMOUNT,
     * weight in the shop weight unit for SHIPPING_RATE_DEFINITION_TYPE_PACKAGE_WEIGHT,
     * and unset for SHIPPING_RATE_DEFINITION_TYPE_FLAT, which has a single
     * unbounded tier. An unset bound is open ended on that side.
     *
     * @generated from field: optional double minimum = 3;
     */
    minimum?: number | undefined;

    /**
     * @generated from field: optional double maximum = 4;
     */
    maximum?: number | undefined;

    /**
     * price is the delivery cost of the tier, in the definition currency.
     *
     * @generated from field: optional double price = 5;
     */
    price?: number | undefined;
};

/**
 * Describes the message settings.v1.ShippingRateTier.
 * Use `create(ShippingRateTierSchema)` to create a new message.
 */
export const ShippingRateTierSchema: GenMessage<ShippingRateTier> =
    /*@__PURE__*/
    messageDesc(file_settings_v1_shipping_rate_tier, 0);
